import { render, staticRenderFns } from "./MsWordIcon.vue?vue&type=template&id=34aa2ca4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34aa2ca4')) {
      api.createRecord('34aa2ca4', component.options)
    } else {
      api.reload('34aa2ca4', component.options)
    }
    module.hot.accept("./MsWordIcon.vue?vue&type=template&id=34aa2ca4", function () {
      api.rerender('34aa2ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MsWordIcon.vue"
export default component.exports